// extracted by mini-css-extract-plugin
export default {"newsHeaderContainer":"NewsHeader_newsHeaderContainer__e+AR8","provider":"NewsHeader_provider__WenIS","headline":"NewsHeader_headline__WSmyP"};